import { Controller, useFormContext } from 'react-hook-form'

import { FF2, SecuredInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TIN = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.tin`}
      control={control}
      render={({ field }) => (
        <FF2 field={field} label="a. Institution TIN" input={(props) => <SecuredInput {...props} maxLength={25} />} />
      )}
    />
  )
}
